import { render, staticRenderFns } from "./FeeSelectionModal.vue?vue&type=template&id=988e17be&scoped=true&"
import script from "./FeeSelectionModal.vue?vue&type=script&lang=js&"
export * from "./FeeSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./FeeSelectionModal.vue?vue&type=style&index=0&id=988e17be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988e17be",
  null
  
)

component.options.__file = "FeeSelectionModal.vue"
export default component.exports